export const dateToString = (str) => {
  if (str === null || str === undefined || str.length === 0) {
    return '';
  }

  const dateFromStr = new Date(str);

  const date = new Date(+dateFromStr + 3240 * 10000)
    .toISOString()
    .split("T")[0];

  const time = dateFromStr.toTimeString().split(" ")[0];

  return `${date} ${time}`;
};

export const onlyDateToString = (str) => {
  if (str === null || str === undefined || str.length === 0) {
    return '';
  }

  const dateFromStr = new Date(str);

  const date = new Date(+dateFromStr + 3240 * 10000)
    .toISOString()
    .split("T")[0];

  const time = dateFromStr.toTimeString().split(" ")[0];

  return `${date}`;
};

export const dateToCompactString = (d) => {
  if (d === null || d === undefined || d.length === 0) {
    return null;
  }
  const date = new Date(+d + 3240 * 10000).toISOString().split("T")[0];

  return `${date}`;
};

export const dateToLongString = (d) => {
  if (d === null || d === undefined || d.length === 0) {
    return null;
  }
  const date = new Date(+d + 3240 * 10000).toISOString();

  return `${date}`;
};

export const startOfMonth = (d) => {
  if (d === null || d === undefined || d.length === 0) {
    return null;
  }
  const date = new Date(d.getFullYear(), d.getMonth(), 2)
    .toISOString()
    .split("T")[0];

  return `${date}`;
};

export const endOfMonth = (d) => {
  if (d === null || d === undefined || d.length === 0) {
    return null;
  }

  const date = new Date(d.getFullYear(), d.getMonth() + 1, 1)
    .toISOString()
    .split("T")[0];

  return `${date}`;
};

export const startOfYear = (d) => {
  if (d === null || d === undefined || d.length === 0) {
    return null;
  }
  const date = new Date(d.getFullYear(), 0, 2).toISOString().split("T")[0];

  return `${date}`;
};

export const endOfYear = (d) => {
  if (d === null || d === undefined || d.length === 0) {
    return null;
  }

  const date = new Date(d.getFullYear(), 12, 1).toISOString().split("T")[0];

  return `${date}`;
};

export const getFileNameFromURL = (url) => {
  if (!url) return;

  let parsed = url?.split("/");
  return parsed[parsed?.length - 1];
};

export const getImageListForUploadFromFlatArr = (arr) => {
  return arr?.map((i) => {
    return {
      ...i,
      name: getFileNameFromURL(i),
      url: i,
      uid: i,
      status: "success",
    };
  });
};

export const getImageListForUpload = (arr) => {
  return arr?.map((i) => {
    return {
      ...i,
      name: getFileNameFromURL(i.image),
      url: i.image,
      uid: i.id,
      status: "success",
    };
  });
};

export const getImageListForUploadFromURL = (url) => {
  if (!url) return null;
  return {
    name: getFileNameFromURL(url),
    url: url,
    uid: url,
    status: "success",
  };
};

export function debounce(func, wait, immediate = false) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}

export function numberWithCommas(x) {
  if (!x) {
    return 0;
  }
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function numberWoCommas(x) {
  if (!x) {
    return 0;
  }
  return parseInt(x.toString().replace(/,/g, ""));
}

export function fillZero(value) {
  if (value >= 10) {
    return value.toString();
  } else {
    return '0' + value;
  }
}

export const getDateTimeString = date => {
  if (!date) return ''
  return (
    date.getFullYear() +
    '.' +
    fillZero(date.getMonth() + 1) +
    '.' +
    fillZero(date.getDate()) +
    ' ' +
    fillZero(date?.getHours()) +
    ':' +
    fillZero(date?.getMinutes())

  );
};

export const getDateString = date => {
  if (!date) return ''
  return (
    date.getFullYear() +
    '.' +
    fillZero(date.getMonth() + 1) +
    '.' +
    fillZero(date.getDate())
  );
};


export function compareObjects(object1, object2, key, isReverse) {
  const obj1 = object1[key];
  const obj2 = object2[key];

  if (obj1 < obj2) {
    return isReverse ? -1 : 1;
  }
  if (obj1 > obj2) {
    return isReverse ? 1 : -1;
  }
  return 0;
}

export function getOrderedList(list, key, isReverse = false) {
  if (!list) return list
  list.sort((first, second) => {
    if (!first[key]) {
      return null;
    }
    return compareObjects(first, second, key, isReverse);
  });
  return list;
}


export const getCode = (code) => {
  if (!code) return ''
  return code.slice(0, 4) + '-' + code.slice(4, 8) + '-' + code.slice(8, 12) + '-' + code.slice(12, 16)
}
